<template>
  <v-row>
    <v-col cols="12" lg="6">
      <regie-card class="mt-2"
                   name="Gudrun"
                   image-src="/Bilder/Regie/Gudrun.jpg"
      >Gudrun Skupin ist seit vielen Jahren als Regisseurin bei Heidekraut tätig.
        Nach ihrem Schauspielstudium an der Folkwang Hochschule und zahlreichen Theaterengagements absolvierte
        sie eine Ausbildung zur Sprecherin beim Bayerischen Rundfunk.
        Ihre Leidenschaft gilt seit über 40 Jahren dem Theater.
      </regie-card>
    </v-col>
    <v-col cols="12" lg="6">
      <regie-card class="mt-2"
                  name="Anschi"
                  image-src="/Bilder/Regie/Anschi.png"
      >"Wer A sagt, der muss nicht B sagen. Er kann auch erkennen, dass A falsch war." (Brecht) <br>
        Im Theaterprozess zu erkennen, dass A tatsächlich oft falsch ist,
        ist zugleich deprimierend, spannend, nervenaufreibend und einfach wunderschön!
      </regie-card>
    </v-col>
  </v-row>
</template>

<script>

import RegieCard from "./RegieCard";

export default {
  name: "RegieAktiv",
  components: {RegieCard},
}
</script>

<style scoped>

</style>